import { ConvertedDimensionsInput } from './converted-dimensions-input';
import style from './style.module.less';
import DimensionsLabel from '../../fulfillment-planner/dimensions/label';

import type { Dimensions } from '../../prop-types/dimension-types';
import type React from 'react';

type BulkConvertedDimensionsFieldProps = {
  dimensions: Dimensions;
  onChange: (dimensions: Dimensions) => void;
};

export const BulkConvertedDimensionsField: React.FC<BulkConvertedDimensionsFieldProps> = ({ dimensions, onChange }) => {
  return (
    <div className={style['drawer-dimensions-input']}>
      <div className={style['dimensions-input-label']}>
        <DimensionsLabel />
      </div>
      <ConvertedDimensionsInput dimensions={dimensions} inputClassName={style['size-input']} onChange={onChange} />
    </div>
  );
};
